import { UPDATE_PATHS } from '../../../helpers/api/apiPaths';
import { patch } from '../../../helpers/api/patch';

const API_UPDATE = 'API_UPDATE';
const loadData = (store, next, resourceAction, resource) => {
  next({ type: `${resourceAction}_LOADING`, resource });

  return patch(`${UPDATE_PATHS[resourceAction]}${resource.id}`, resource)
    .then(
      response => store.dispatch({ type: `${resourceAction}_SUCCESS`, id: resource.id, response }),
      () => store.dispatch({ type: `${resourceAction}_FAILED`, resource }),
    );
};

export default store => next =>
  action =>
    ((action.resourceAction && action.resourceAction.startsWith(API_UPDATE) && action.resource)
      ? loadData(store, next, action.resourceAction, action.resource)
      : next(action));



// WEBPACK FOOTER //
// ./src/reducers/middleware/resourceUpdater/resourceUpdater.middleware.js